module.exports = __webpack_public_path__ + "img/scan_preview.0ad2f33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/type-setting/scan_preview.svg
// module id = C0WF
// module chunks = 1